import { Component, OnInit, inject } from "@angular/core";
import { ReleaseNotesService } from "../../services/release-notes/release-notes.service";
import { Observable } from "rxjs";
import { MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from "@angular/material/dialog";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatButton } from "@angular/material/button";
import { AsyncPipe } from "@angular/common";
import { MatChip } from "@angular/material/chips";

@Component({
  selector: "igv-update-prompt",
  templateUrl: "./update-prompt.component.html",
  styleUrls: ["./update-prompt.component.scss"],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatProgressSpinner,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    AsyncPipe,
    MatChip,
  ],
})
export class UpdatePromptComponent implements OnInit {
  private releaseNotesService = inject(ReleaseNotesService);

  appVersion$!: Observable<any>;

  ngOnInit(): void {
    this.appVersion$ = this.releaseNotesService.getAppVersion();
  }
}
